import { FC } from 'react';
import usePortal from 'react-useportal';
import { useInert } from 'app/hooks';
import {
  Cross,
  ModalContainer,
  ModalContentWrapper,
  ModalWrapper,
} from './modal.styled';
import { ReactComponent as CrossIcon } from 'assets/svg/cross.svg';

interface IModalProps {
  isOpen: boolean;
  onClose: () => void;
  minHeight?: number;
}

export const Modal: FC<IModalProps> = ({
  isOpen,
  onClose,
  minHeight,
  children,
}) => {
  const { Portal } = usePortal();
  useInert(isOpen);

  return isOpen ? (
    <Portal>
      <ModalWrapper onClick={onClose}>
        <ModalContentWrapper>
          <ModalContainer
            minHeight={minHeight}
            onClick={(e) => e.stopPropagation()}
          >
            <Cross onClick={onClose}>
              <CrossIcon color="#89929B" />
            </Cross>
            {children}
          </ModalContainer>
        </ModalContentWrapper>
      </ModalWrapper>
    </Portal>
  ) : null;
};
